export const LOADING = "LOADING";
export const REVIEWS = "REVIEWS";
export const PLATFORM_CONFIGURATION = "PLATFORM_CONFIGURATION";